import { render } from "./Defending.vue?vue&type=template&id=144c14d6"
import script from "./Defending.vue?vue&type=script&lang=js"
export * from "./Defending.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__